module.exports = __webpack_public_path__ + "img/unionpay.328b7fba.svg";